
import BaseModel from './BaseModel';
import { getMomentDate } from '../utils/commonUtils';

export default class VinWonder extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.siteCode = data.siteCode || this.translate.siteCode || undefined;
        this.siteCodeString = data.siteCodeString || this.translate.siteCodeString || undefined;
        this.isAvailable = data.isAvailable || false;
        this.isSpecial = data.isSpecial || false;
        // this.isHot = data.isHot || false;
        this.imagesView = data.imagesView || this.translate.imagesView || [];
        this.thumbImage = data.thumbImage || this.translate.thumbImage || undefined;
        this.thumbImageView = data.thumbImageView || (this.translate.thumbImage ? this.translate.thumbImageView : undefined) || undefined;
        this.images = Array.isArray(data.images || this.translate.images) ? data.images || this.translate.images : [];
        this.shortDescription = data.shortDescription || this.translate.shortDescription || undefined;
        this.description = data.description || this.translate.description || undefined;
        this.highLight = data.highLight || this.translate.highLight || undefined;
        this.conditionOfUse = data.conditionOfUse || this.translate.conditionOfUse || undefined;
        this.operationManuals = data.operationManuals || this.translate.operationManuals || undefined;
        this.urlSlug = data.urlSlug || undefined;
        this.isDefault = data.isDefault || false;
        this.createdDate = data.createdDate || undefined;
        this.vinWonderCode = data.vinWonderCode || undefined;
        this.saleEndDate = getMomentDate(data.saleEndDate);
        this.saleStartDate = getMomentDate(data.saleStartDate);
        this.blackOutReason = data.blackOutReason || undefined;
        this.blackOutStartDate = getMomentDate(data.blackOutStartDate);
        this.blackOutEndDate = getMomentDate(data.blackOutEndDate);
        this.order = data.order || 0;
        this.limitNumberOfSalesPerUser = data.limitNumberOfSalesPerUser || 0;
        this.installmentFee = data.installmentFee;
        this.installmentLimit = data.installmentLimit;
        this.vinWonderSites = data.vinWonderSites;
        this.type = data.type || this.translate.type || undefined;
        this.vinWonderTypes = data.vinWonderTypes;
        this.typeName = data.typeName || undefined
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            siteCode: this.siteCode,
            siteCodeString: this.siteCodeString,
            isAvailable: this.isAvailable,
            isSpecial: this.isSpecial,
            // isHot: this.isHot,
            imagesView: this.imagesView,
            thumbImage: this.thumbImage,
            thumbImageView: this.thumbImageView,
            images: this.images,
            shortDescription: this.shortDescription,
            description: this.description,
            highLight: this.highLight,
            conditionOfUse: this.conditionOfUse,
            operationManuals: this.operationManuals,
            urlSlug: this.urlSlug,
            isDefault: this.isDefault,
            createdDate: this.createdDate,
            vinWonderCode: this.vinWonderCode,
            saleEndDate: this.saleEndDate && (this.saleEndDate).toISOString(),
            saleStartDate: this.saleStartDate && (this.saleStartDate).toISOString(),
            blackOutStartDate: this.blackOutStartDate && (this.blackOutStartDate).toISOString(),
            blackOutEndDate: this.blackOutEndDate && (this.blackOutEndDate).toISOString(),
            blackOutReason: this.blackOutReason,
            order: Number(this.order),
            limitNumberOfSalesPerUser: this.limitNumberOfSalesPerUser,
            installmentFee: this.installmentFee,
            installmentLimit: this.installmentLimit,
            vinWonderSites: this.vinWonderSites,
            type: this.type,
            vinWonderTypes: this.vinWonderTypes
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                vinWonderId: this.translate.vinWonderId || this.id,
                name: this.name,
                thumbImage: this.thumbImage,
                thumbImageView: this.thumbImageView,
                images: this.images,
                imagesView: this.imagesView,
                shortDescription: this.shortDescription,
                description: this.description,
                highLight: this.highLight,
                conditionOfUse: this.conditionOfUse,
                operationManuals: this.operationManuals,
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}

export const siteCodes = [
    {
        id: 7610,
        value: 'PHUQUOCVAP',
        text: 'Phú Quốc',

    },
    {
        id: 7613,
        value: 'PHUQUOCSAF',
        text: 'Safari Phú Quốc'
    },
    {
        id: 7601,
        value: 'NHATRANG',
        text: 'Nha Trang'
    },
    {
        id: 7630,
        value: 'NAMHOIAN',
        text: 'Nam Hội An'
    },
    {
        id: 7014,
        value: 'TIMECITY',
        text: 'Times City'
    }
]